import React, { useMemo } from 'react'
import { hasAuth } from 'meinian-package/src/utils/auth'
import { SwitchTabBorder } from '../../../../components/switchTab'

export default ({ tabMoveInspirationParams, setTabMoveInspirationParams }) => {
  const option = useMemo(() => {
    const _option = [
      { label: '淘宝商品', value: 8, auth: hasAuth('dl_monitor_center') },
      { label: 'INS帖子', value: 11, auth: hasAuth('dl_ins') },
      { label: '小红书帖子', value: 37, auth: hasAuth('dl_ins') }
    ]
    return _option.filter(i => i.auth)
  }, [])
  return <SwitchTabBorder
    value={tabMoveInspirationParams.cardType}
    allowClear
    options={option}
    onChange={(val) => {
      setTabMoveInspirationParams(pre => ({
        ...pre,
        cardType: val
      }))
    }}
  />
}
